import { TextField, TextFieldProps } from '@mui/material';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { CurrencyApplicationEnum, ForecastByRoomTypeReportFormModel } from '../../../models';

export const FixedAtField: FC<
  TextFieldProps & {
    value: string | null;
    onChange: (value: string | null) => void;
  }
> = ({ value, onChange, ...props }) => {
  const { watch } = useFormContext<ForecastByRoomTypeReportFormModel>();
  const selectedCurrencyApplication = watch('currency_application');
  const disabled =
    selectedCurrencyApplication === null ||
    selectedCurrencyApplication === CurrencyApplicationEnum.DAILY;

  return (
    <TextField
      disabled={disabled}
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      variant="standard"
      fullWidth
      label={'Fixed At'}
      helperText={props?.helperText}
    />
  );
};
